module.exports = __webpack_public_path__ + "img/applepay-light.b47593da.svg";